export default __webpack_public_path__ + "02ab7b8d.jpg";